/**
 * Show/hide preloader
 *
 * @param flag - boolean, does preloader should be shown
 * @param $container - jquery obj
 */
export default (flag, $container) => {
  const preloaderClass = '.search__preloader';
  const preloader = '<div class="search__preloader"><div class="md-preloader preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="40" width="40" viewBox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"></circle></svg></div></div>';

  if (flag && !$(preloaderClass).length) {
    $container.append(preloader);
  } else {
    $(preloaderClass).remove();
  }
};
